import { Navigate, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";

import {
  getAccessToken,
  isLoggedInAtom,
  isValidAppPath,
  localStorageHelpers,
} from "@ryde/shared";

export const ProtectedRoute = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const token = getAccessToken();
  const isLoggedIn = useRecoilValue(isLoggedInAtom);
  const location = useLocation();

  if (!token && !isLoggedIn) {
    if (isValidAppPath(location.pathname)) {
      localStorageHelpers.setItem(
        "returnTo",
        `${location.pathname}${location.search}`,
      );
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};
